import { useEffect, useState } from 'react';
import { FiArrowLeft, FiMenu, FiX } from 'react-icons/fi';
import { Link, Outlet, useLocation } from 'react-router-dom';

import styles from '@/admin/AdminLayout.module.scss';
import { AdminSidebar } from '@/admin/components/AdminSidebar';

export const AdminLayout = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer on route changes (e.g. browser back/forward) —
  // adjusted during render per React's guidance instead of a setState-in-effect.
  const [lastPathname, setLastPathname] = useState(location.pathname);
  if (location.pathname !== lastPathname) {
    setLastPathname(location.pathname);
    setIsDrawerOpen(false);
  }

  // Admin paints its own always-light surface, but overlays portalled to <body> (the
  // update toast) still read the app-wide theme tokens — under dark theme that is white
  // text on a translucent white card sitting over our white page. Flag the document
  // while admin is mounted so those overlays can opt into the admin palette.
  useEffect(() => {
    document.documentElement.dataset.vhAdmin = 'true';
    return () => {
      delete document.documentElement.dataset.vhAdmin;
    };
  }, []);

  const closeDrawer = () => setIsDrawerOpen(false);

  return (
    <div className={styles.root}>
      <div className={styles.topbar}>
        <button
          type="button"
          className={styles.menuButton}
          aria-label={isDrawerOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setIsDrawerOpen((open) => !open)}
        >
          {isDrawerOpen ? <FiX /> : <FiMenu />}
        </button>
        <span className={styles.topbarBrand}>VH Admin</span>
      </div>

      {isDrawerOpen && <div className={styles.backdrop} onClick={closeDrawer} />}

      <aside className={`${styles.sidebar} ${isDrawerOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.brand}>VH Admin</div>
        <Link to="/settings" className={styles.exitLink} onClick={closeDrawer}>
          <FiArrowLeft />
          Back to app
        </Link>
        <hr className={styles.hr} />
        <AdminSidebar onNavigate={closeDrawer} />
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};
